var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgEmergency = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "currentColor",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M5.016 11.616h13.968l-1.488-4.512H6.528zm12.48 4.968q.624 0 1.056-.432t.432-1.08-.432-1.068-1.056-.42-1.068.432-.444 1.056.432 1.068 1.08.444m-10.968 0q.624 0 1.056-.432t.432-1.08-.432-1.068-1.056-.42-1.068.432-.444 1.056.432 1.068 1.08.444M18.936 6.6l2.064 6v10.016a.95.95 0 0 1-.288.696.95.95 0 0 1-.696.288h-1.032a.95.95 0 0 1-.696-.288.95.95 0 0 1-.288-.696v-1.032H6v1.032a.95.95 0 0 1-.288.696.95.95 0 0 1-.696.288H3.984a.95.95 0 0 1-.696-.288.95.95 0 0 1-.288-.696V12.6l2.064-6q.144-.456.552-.72t.912-.264h10.968q.504 0 .9.264t.54.72"
}), /*#__PURE__*/React.createElement("rect", {
  width: 3,
  height: 3,
  x: 11,
  y: 4,
  rx: 1.5
}), /*#__PURE__*/React.createElement("rect", {
  width: 2,
  height: 3,
  x: 11.5,
  rx: 1
}), /*#__PURE__*/React.createElement("rect", {
  width: 2,
  height: 2.561,
  x: 14.612,
  y: 1.582,
  rx: 1,
  transform: "rotate(45 15.612 2.862)"
}), /*#__PURE__*/React.createElement("rect", {
  width: 2,
  height: 2.518,
  x: 8.597,
  y: 1.619,
  rx: 1,
  transform: "scale(-1 1)rotate(45 0 -20.292)"
}))));
export default SvgEmergency;